import script from "./GoSignUp.vue?vue&type=script&lang=ts&setup=true"
export * from "./GoSignUp.vue?vue&type=script&lang=ts&setup=true"

import "./GoSignUp.vue?vue&type=style&index=0&id=a2490bda&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2490bda"]])

export default __exports__